import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Title } from 'chart.js';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomePageModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  {
    path: 'pendaprobacion',
    loadChildren: () => import('./pendaprobacion/pendaprobacion.module').then(m => m.PendaprobacionPageModule),
    data: { title: 'Pendientes', subtitle: 'Solicitudes' }
  },
  {
    path: 'hisaprobacion',
    loadChildren: () => import('./hisaprobacion/hisaprobacion.module').then(m => m.HisaprobacionPageModule),
    data: { title: 'Historial', subtitle: 'Solicitudes' }
  },
  {
    path: 'liquidaciones',
    loadChildren: () => import('./liquidaciones/liquidaciones.module').then(m => m.LiquidacionesPageModule),
    data: { title: 'Generar', subtitle: 'Liquidaciones' }
  },
  {
    path: 'hisliquidaciones',
    loadChildren: () => import('./hisliquidaciones/hisliquidaciones.module').then(m => m.HisliquidacionesPageModule),
    data: { title: 'Historial', subtitle: 'Liquidaciones' }
  },
  { path: 'negar', loadChildren: () => import('./components/negar/negar.module').then(m => m.NegarPageModule) },
  {
    path: 'reportes',
    loadChildren: () => import('./reportes/reportes.module').then(m => m.ReportesPageModule),
    data: { title: 'Reportes', subtitle: 'Liquidaciones' }
  },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule) },
  { path: 'edit-emp', loadChildren: () => import('./components/edit-emp/edit-emp.module').then(m => m.EditEmpPageModule) },
  { path: 'cuadro-pagare', loadChildren: () => import('./components/cuadro-pagare/cuadro-pagare.module').then(m => m.CuadroPagarePageModule) },
  {
    path: 'historial-puntos',
    loadChildren: () => import('./historial-puntos/historial-puntos.module').then(m => m.HistorialPuntosPageModule),
    data: { title: 'Historial', subtitle: 'Puntos denario' }
  },
  {
    path: 'dashboard-puntos',
    loadChildren: () => import('./dashboard-puntos/dashboard-puntos.module').then(m => m.DashboardPuntosPageModule),
    data: { title: 'Dashboard', subtitle: 'Puntos denario' }
  },
  {
    path: 'distribuir-puntos',
    loadChildren: () => import('./distribuir-puntos/distribuir-puntos.module').then(m => m.DistribuirPuntosPageModule),
    data: { title: 'Distribuir', subtitle: 'Puntos denario' }
  },
  {
    path: 'denarios-pendientes-g4s',
    loadChildren: () => import('./denarios-pendientes-g4s/denarios-sols-pendientes.module').then(m => m.DenariosSolsPendientesPageModule),
    data: { title: 'Pendientes', subtitle: 'Puntos denario' }
  },
  { path: 'editar-hotel', loadChildren: () => import('./components/editar-hotel/editar-hotel.module').then(m => m.EditarHotelPageModule) },
  {
    path: 'denarios-historial-g4s',
    loadChildren: () => import('./denarios-historial-g4s/denarios-historial-g4s.module').then(m => m.DenariosHistorialG4sPageModule),
    data: { title: 'Historial', subtitle: 'Puntos denario' }
  },
  { path: 'formulario/:id', loadChildren: () => import('./formulario/formulario.module').then(m => m.FormularioPageModule) },
  { path: 'formulario', loadChildren: () => import('./formulario/formulario.module').then(m => m.FormularioPageModule) },
  { path: 'usuarios-superadmin', loadChildren: () => import('./usuarios-superadmin/usuarios-superadmin.module').then(m => m.UsuariosSuperAdminPageModule) },
  {
    path: 'solicitar-dcard',
    loadChildren: () => import('./solitar-dcard/solitar-dcard.module').then(m => m.SolitarDcardPageModule),
    data: { title: 'Nueva solicitud', subtitle: 'Dcard - Solicitudes' }
  },
  {
    path: 'dcard-sols-pendientes',
    loadChildren: () => import('./dcard-solicitudes-pendientes/dcard-sols-pendientes.module').then(m => m.DCardSolsPendientesPageModule),
    data: { title: 'Pendientes', subtitle: 'Dcard - Solicitudes' }
  },
  {
    path: 'historial-solicitudes-dcard',
    loadChildren: () => import('./dcard-historial-solicitudes/historial-solicitudes-dcard.module').then(m => m.HistorialSolicitudesDcardPageModule),
    data: { title: 'Historial', subtitle: 'Dcard - Solicitudes' }
  },
  {
    path: 'viajes',
    loadChildren: () => import('./viajes/viajes.module').then(m => m.ViajesPageModule),
    data: { title: 'Historial', subtitle: 'Viajes' }
  },
  {
    path: 'ver-usuarios',
    loadChildren: () => import('./usuarios/ver-usuarios/ver-usuarios.module').then(m => m.VerUsuariosPageModule),
    data: { title: 'Ver usuarios', subtitle: 'Usuarios' }
  },
  {
    path: 'registrar-usuarios',
    loadChildren: () => import('./usuarios/registrar-usuarios/registrar-usuarios.module').then(m => m.RegistrarUsuariosPageModule),
    data: { title: 'Crear usuarios', subtitle: 'Usuarios' }
  },
  {
    path: 'bolsas',
    loadChildren: () => import('./modules/bolsas/pages/bolsas/bolsas.module').then(m => m.BolsasPageModule),
    data: { title: 'Saldo y movimientos', subtitle: 'Dcard - Bolsas' }
  },
  {
    path: 'solicitar-bolsa',
    loadChildren: () => import('./modules/bolsas/pages/solicitar-bolsa/solicitar-bolsa.module').then(m => m.SolicitarBolsaPageModule),
    data: { title: 'Nueva solicitud', subtitle: 'Dcard - Bolsas' }
  },
  {
    path: 'detalle-bolsa', loadChildren: () => import('./modules/bolsas/pages/detalle-bolsa/detalle-bolsa.module').then(m => m.DetalleBolsaPageModule)
  },
  {
    path: 'pendienterevision',
    loadChildren: () => import('./modules/bolsas/pages/pendienterevision/pendienterevision.module').then(m => m.PendienterevisionPageModule),
    data: { title: 'Pendiente revisión', subtitle: 'Dcard - Facturación' }
  },
  {
    path: 'pendiente-facturacion',
    loadChildren: () => import('./pages/pendiente-facturacion/pendiente-facturacion.module').then(m => m.PendienteFacturacionModule),
    data: { title: 'Pendiente facturación', subtitle: 'Dcard - Facturación' }
  },
  {
    path: 'facturado',
    loadChildren: () => import('./pages/facturado/facturado.module').then(m => m.FacturadoModule),
    data: { title: 'Facturado', subtitle: 'Dcard - Facturación' }
  },
  {
    path: 'convenios-lista',
    loadChildren: () => import('./admin/convenios/pages/convenios-lista/convenios-list.module').then(m => m.ConveniosListPageModule),
    data: { title: 'Convenios', subtitle: 'Dcard - Administración' }
  },
  {
    path: 'convenio-crear',
    loadChildren: () => import('./admin/convenios/pages/convenio-crear/convenio-create.module').then(m => m.ConvenioCreatePageModule),
    data: { title: 'Nuevo', subtitle: 'Dcard - Administración - Convenios' }
  },
  {
    path: 'convenio-detalle/:id', loadChildren: () => import('./admin/convenios/pages/convenio-detalle/convenio-detail.module').then(m => m.ConvenioDetailPageModule)
  },
  {
    path: 'transacciones',
    loadChildren: () => import('./admin/convenios/pages/transacciones/transacciones.module').then(m => m.TransaccionesPageModule),
    data: { title: 'Transacciones', subtitle: 'Dcard - Administración' }
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./admin/convenios/pages/usuarios/usuarios.module').then(m => m.UsuariosPageModule),
    data: { title: 'Usuarios', subtitle: 'Dcard - Administración' }
  },
  {
    path: 'usuario-detalle/:id',
    loadChildren: () => import('./admin/convenios/pages/usuario-detalle/usuario-detalle.module').then(m => m.UsuarioDetallePageModule),
    data: { subtitle: 'Dcard - Administración - Usuarios' }
  },
  {
    path: 'tarjetas',
    loadChildren: () => import('./admin/convenios/pages/tarjetas/tarjetas.module').then(m => m.TarjetasPageModule),
    data: { title: 'Tarjetas', subtitle: 'Dcard - Administración' }
  },
  {
    path: 'tarjeta-detalle/:id',
    loadChildren: () => import('./admin/convenios/pages/tarjeta-detalle/tarjeta-detalle.module').then(m => m.TarjetaDetallePageModule),
    data: { subtitle: 'Dcard - Administración - Tarjetas' }
  },
  {
    path: 'metricas-convenios',
    loadChildren: () => import('./admin/convenios/pages/rentabilidad/metricas-convenios/metricas-convenios.module').then(m => m.MetricasConveniosPageModule),
    data: { title: 'Convenios', subtitle: 'Dcard - Metricas' }
  },
  {
    path: 'metricas-convenio-detalle/:id',
    loadChildren: () => import('./admin/convenios/pages/rentabilidad/metricas-convenio-detalle/metricas-convenio-detalle.module').then(m => m.MetricasConvenioDetallePageModule),
    data: { subtitle: 'Dcard - Metricas - Convenios' }
  },
  {
    path: 'configuracion',
    loadChildren: () => import('./empresa/pages/configuracion/configuracion.module').then(m => m.ConfiguracionPageModule),
    data: { title: 'Configuración', subtitle: 'Dcard - Mi empresa' }
  },
  {
    path: 'usuarios-empresa',
    loadChildren: () => import('./empresa/pages/usuarios/usuarios.module').then(m => m.UsuariosPageModule),
    data: { title: 'Usuarios', subtitle: 'Dcard - Mi empresa' }
  },
  {
    path: 'usuario-empresa-detalle/:id',
    loadChildren: () => import('./empresa/pages/usuario-detalle/usuario-detalle.module').then(m => m.UsuarioDetallePageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Mi empresa - Usuarios' }
  },
  {
    path: 'usuarios-empresa/tarjetas',
    loadChildren: () => import('./empresa/pages/tarjetas/tarjetas.module').then(m => m.TarjetasPageModule),
    data: { title: 'Tarjetas', subtitle: 'Dcard - Mi empresa' }
  },
  {
    path: 'usuarios-empresa/transacciones',
    loadChildren: () => import('./empresa/pages/transacciones/transacciones.module').then(m => m.TransaccionesPageModule),
    data: { title: 'Transacciones', subtitle: 'Dcard - Mi empresa' }
  },
  {
    path: 'metricas-recargas',
    loadChildren: () => import('./admin/convenios/pages/rentabilidad/reportes/recargas/recargas.module').then(m => m.RecargasPageModule),
    data: { title: 'Recargas', subtitle: 'Dcard - Metricas' }
  },
  {
    path: 'metricas-transacciones',
    loadChildren: () => import('./admin/convenios/pages/rentabilidad/reportes/transacciones/transacciones.module').then(m => m.TransaccionesPageModule),
    data: { title: 'Transacciones', subtitle: 'Dcard - Metricas' }
  },
  {
    path: 'control-ordenes-compra',
    loadChildren: () => import('./modules/bolsas/pages/control-ordenes-compra/control-ordenes-compra.module').then(m => m.ControlOrdenesCompraPageModule),
    data: { title: 'Órdenes de compra', subtitle: 'Dcard - Bolsas' }
  },
  {
    path: 'administracion-ordenes-compra',
    loadChildren: () => import('./admin/convenios/pages/administracion-ordenes-compra/administracion-ordenes-compra.module').then(m => m.AdministracionOrdenesCompraPageModule),
    data: { title: 'Ordenes de Compra', subtitle: 'Dcard - Administración' }
  },
  {
    path: 'detalle-ordenes-compra-convenio/:convenioId',
    loadChildren: () => import('./admin/convenios/pages/detalle-ordenes-compra-convenio/detalle-ordenes-compra-convenio.module').then(m => m.DetalleOrdenesCompraConvenioPageModule),
    data: { title: 'Ordenes de compra', subtitle: 'Dcard - Administración - Ordenes de compra' }
  },
  {
    path: 'historial-recargas-lotes',
    loadChildren: () => import('./pages/historial-recargas-lotes/historial-recargas-lotes.module').then(m => m.HistorialRecargasLotesPageModule),
    data: { title: 'Recargas por lote', subtitle: 'Dcard - Historicos' }
  },
  {
    path: 'historial-recargas-lotes/convenio/:convenioId',
    loadChildren: () => import('./pages/historial-recargas-lotes/historial-recargas-lotes.module').then(m => m.HistorialRecargasLotesPageModule)
  },
  {
    path: 'historial-recargas-lote/:id',
    loadChildren: () => import('./pages/detalle-recarga-lote/detalle-recarga-lote.module').then(m => m.DetalleRecargaLotePageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Historicos - Recargas por lote' }
  },
  {
    path: 'historial-recargas-lotes/:id',
    loadChildren: () => import('./pages/detalle-recarga-lote/detalle-recarga-lote.module').then(m => m.DetalleRecargaLotePageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Solicitudes - Historial' }
  },
  {
    path: 'historial-recargas-bolsa',
    loadChildren: () => import('./pages/historial-recargas-bolsa/historial-recargas-bolsa.module').then(m => m.HistorialRecargasBolsaPageModule),
    data: { title: 'Recargas de bolsa', subtitle: 'Dcard - Historicos' }
  },
  {
    path: 'detalle-recarga-bolsa/:id',
    loadChildren: () => import('./pages/detalle-recarga-bolsa/detalle-recarga-bolsa.module').then(m => m.DetalleRecargaBolsaPageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Historicos - Recargas de bolsa' }
  },
  {
    path: 'historial-liquidaciones',
    loadChildren: () => import('./pages/historial-liquidaciones/historial-liquidaciones.module').then(m => m.HistorialLiquidacionesPageModule),
    data: { title: 'Liquidaciones', subtitle: 'Dcard - Historicos' }
  },
  {
    path: 'detalle-liquidacion/:id',
    loadChildren: () => import('./pages/detalle-liquidacion/detalle-liquidacion.module').then(m => m.DetalleLiquidacionPageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Historicos - Liquidaciones' }
  },
  {
    path: 'historial-simulaciones',
    loadChildren: () => import('./pages/historial-simulaciones/historial-simulaciones.module').then(m => m.HistorialSimulacionesPageModule),
    data: { title: 'Simulaciones', subtitle: 'Dcard - Historicos' }
  },
  {
    path: 'detalle-simulacion/:tipo/:id',
    loadChildren: () => import('./pages/detalle-simulacion/detalle-simulacion.module').then(m => m.DetalleSimulacionPageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Historicos - Simulaciones' }
  },
  {
    path: 'historial-notificaciones',
    loadChildren: () => import('./pages/historial-notificaciones/historial-notificaciones.module').then(m => m.HistorialNotificacionesPageModule),
    data: { title: 'Notificaciones', subtitle: 'Dcard - Historicos' }
  },
  {
    path: 'detalle-notificacion/:id',
    loadChildren: () => import('./pages/detalle-notificacion/detalle-notificacion.module').then(m => m.DetalleNotificacionPageModule),
    data: { title: 'Detalle', subtitle: 'Dcard - Historicos - Notificaciones' }
  }, {
    path: 'aprobacion-interna-creditos',
    loadChildren: () => import('./pages/aprobacion-interna-creditos/aprobacion-interna-creditos.module').then(m => m.AprobacionInternaCreditosPageModule)
  },
  {
    path: 'revision-credito-interna/:numSol',
    loadChildren: () => import('./pages/revision-credito-interna/revision-credito-interna.module').then(m => m.RevisionCreditoInternaPageModule)
  },
  {
    path: 'aprobacion-interna/revision-documento-interna/:id',
    loadChildren: () => import('./pages/revision-documento-interna/revision-documento-interna.module').then(m => m.RevisionDocumentoInternaPageModule)
  },
  {
    path: 'pqr',
    loadChildren: () => import('./pages/pqr/pqr.module').then((m) => m.PqrModule),
    data: { title: 'Gestión de PQR' }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
